
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import EmojiComp from '@xt/www/components/emoji/index.vue'
import StickerSelect from '@xt/www/components/stickerSelect/index.vue'
import { withSchemaPattern } from '@xt/client/utils/sticker'
import AtList from './at-list.vue'
import Question from './question.vue'

@Observer
@Component({
  components: {
    EmojiComp,
    AtList,
    Question,
    StickerSelect
  }
})
export default class LivePageView extends Vue {
  word = ''
  visibleQARecord = false
  visibleEmoji = false
  visibleSticker = false
  visibleAtList = false
  selectionStart = 0
  isComposition = false

  get PageStore() {
    return this.$store.$genseeLive
  }

  @Ref('input-box')
  inputBox: any

  keyDownHandler(e: KeyboardEvent) {
    if (this.isComposition) return
    if (e.key === 'Enter') {
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) {
        this.word += '\n'
      } else {
        this.onSubmitChat()
      }
    }
  }

  handleClickUnReadCount() {
    const el = document.getElementById('comment-scroll')

    if (el instanceof HTMLDivElement) {
      el.scrollTo(0, el.scrollHeight)
    }
  }

  compositionstartHandler() {
    this.isComposition = true
  }

  compositionendHandler() {
    this.isComposition = false
  }

  textFocusHandler() {
    window.addEventListener('keydown', this.keyDownHandler)
    window.addEventListener('compositionstart', this.compositionstartHandler)
    window.addEventListener('compositionend', this.compositionendHandler)
  }

  textBlurHandler() {
    const node = this.inputBox.$el as HTMLTextAreaElement
    this.selectionStart = typeof node.selectionStart === 'number' ? node.selectionStart : this.word.length
    window.removeEventListener('keydown', this.keyDownHandler)
    window.removeEventListener('compositionstart', this.compositionstartHandler)
    window.removeEventListener('compositionend', this.compositionendHandler)
  }

  chooseHandler(emoji: string) {
    this.word = this.word.slice(0, this.selectionStart).concat(emoji).concat(this.word.slice(this.selectionStart))
    this.selectionStart += emoji.length
  }

  async selectSticker(sticker) {
    // 先将贴纸选择框关闭，防止多次发送
    this.visibleSticker = false
    // 发送贴纸
    const result = await this.PageStore.submitChatMessage(withSchemaPattern(sticker))
    if (result) {
      this.$msg(result)
      return
    }
  }

  async onSubmitChat() {
    const result = await this.PageStore.submitChatMessage(this.word)
    if (result) {
      this.$msg(result)
      return
    }
    this.word = ''
  }

  onVisible(visible: boolean, type: 'emoji' | 'at' | 'sticker') {
    this.resetClickHandler()
    if (visible) {
      switch (type) {
        case 'emoji':
          this.visibleEmoji = visible
          break
        case 'at':
          this.visibleAtList = visible
          break
        case 'sticker':
          this.visibleSticker = visible
          break
      }
      this.recoverClickHandler()
    }
  }

  clickHandler(e: MouseEvent) {
    const node = e.target as HTMLElement
    const id = node.offsetParent?.id
    if (id && id.startsWith('live-operation-trigger')) return
    this.resetClickHandler()
  }

  resetClickHandler() {
    this.visibleEmoji = false
    this.visibleSticker = false
    this.visibleAtList = false
    this.visibleQARecord = false
    document.removeEventListener('click', this.clickHandler)
  }

  recoverClickHandler() {
    document.addEventListener('click', this.clickHandler)
  }

  created() {}
  mounted() {}
  destroyed() {}
}
